import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import Title from './../components/Title'
import { InnerLayout } from '../styles/Layouts'
import ContactInfoItem from './../components/ContactInfoItem'
import EmailIcon from '@material-ui/icons/Email'
import LocationOnIcon from '@material-ui/icons/LocationOn'
import Loading from './../components/Loading'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

function ContactPage({ theme }) {
  const [swLoaded, setSwLoaded] = useState(false)
  const email = <EmailIcon />
  const location = <LocationOnIcon />

  useEffect(() => {
    setTimeout(function() {
      setSwLoaded(true)
    }, 100)
  }, [])

  return (
    !swLoaded ? <Loading /> : <ContactPageStyled>
      <ToastContainer theme={theme === 'light-mode' ? 'light' : 'dark'}/>
      <Title title={'Contact'} span={'Moi'} />
      <InnerLayout className="contact-section">
        <div className="contact-info">
          <h4>Informations</h4>
          <ContactInfoItem icon={email} heading={'Email'} text={'stephane [at] bressani [point] dev'} />
          <ContactInfoItem icon={location} heading={'Localisation'} text={'Genève'} />
        </div>
      </InnerLayout>
    </ContactPageStyled>
  )
}

const ContactPageStyled = styled.div`
  /* fade */
  -webkit-animation: my-fade 1s; /* Chrome, Safari, Opera */
  animation: my-fade 1s;
  .contact-section {
    display:grid;
    grid-template-columns: repeat(2, 1fr);
    grid-gap:3rem;
    @media screen and (max-width:768px){
      grid-template-columns: repeat(1, 1fr);
    }
    .contact-info {
      display: grid;
      grid-template-columns: repeat(1, 1fr);
      width:100%;
      h4{
        padding: 1rem 0;
        font-size:1.8rem;
        @media screen and (max-width:600px) {
            font-size:1.5rem;
        }
      }
    }
    .form-part {
      width:100%;
      h4{
        padding: 1rem 0;
        font-size:1.8rem;
        @media screen and (max-width:600px){
          font-size:1.5rem;
        }
      }
      .form-group {
        margin-top:2rem;
        position: relative;
        width:100%;
        label {
          position: absolute;
          left:20px;
          top: -17px;
          display: inline-block;
          background-color: var(--background-color);
          padding: 0 .5rem;
          color: inherit;
        }
        input {
          border: 1px solid var(--border-color-2);
          outline: none;
          background-color: transparent;
          padding: 10px 15px;
          width:100%;
          color: inherit;
          border-radius: .2rem;
          background-color: transparent;
        }
        textarea {
          resize: none;
          background-color: transparent;
          border: 1px solid var(--border-color-2);
          outline: none;
          color: inherit;
          width: 100%;
          padding: .8rem 1rem;
          border-radius: .2rem;
        }
      }
    }
  }
`

export default ContactPage
